import type { NavItemConfig } from "@/types/nav";

export function isNavItemActive({
	disabled,
	external,
	href,
	matcher,
	pathname,
	except,
}: Pick<NavItemConfig, "disabled" | "external" | "href" | "matcher"> & { pathname: string; except?: string[] }): boolean {
	if (disabled || !href || external) {
		return false;
	}

	if (matcher) {
		if (matcher.type === "startsWith") {
			return pathname.startsWith(matcher.href);
		}

		if (matcher.type === "equals") {
			return pathname === matcher.href;
		}

		return false;
	}

  const pathItems = pathname.split("/");
  const hrefItems = href.split("/");

  if (except?.some(b => pathname.startsWith(b))) {
    return false;
  }

  if (hrefItems.length > 2) {
		return pathItems.slice(0, 3).join("/") === hrefItems.slice(0, 3).join("/");
	}

	return pathItems.slice(0, 2).join("/") === hrefItems.slice(0, 2).join("/");
}
